<ion-header class="{{ noBorder ? 'ion-no-border' : 'bottom-border' }}">
  <ion-toolbar style="--background: {{ backgroundColor }}; --border-color: {{ foregroundColor }}" class="ion-text-center">
    <ion-title style="color:{{ foregroundColor }}">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
